export default function capitalize(str: string | null = ""): string {
  if (!str) return "";
  if (typeof str !== "string") return str;

  return str.charAt(0).toUpperCase() + str.slice(1);
}
